import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { apisiseci } from "../../api";
import { Cancellation } from "../../../@types/cancellation";

export type CancellationCreateData = {
  titulo: string;
  texto: string;
  data: string; // formato "YYYY-MM-DD"
  ativo: boolean;
  presencial: boolean;
  reagendar_presencial: boolean;
  online: boolean;
  geral: boolean;
  slug_unidade?: string
};

export function useCancellationCreate() {
    const history = useHistory();
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["cancellation", "create"],
        mutationFn: async (data: CancellationCreateData) => {
            const response = await apisiseci.post<Cancellation>(
                '/cms/cancelamentos/', data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                }
            );
            return response.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ["cancellation", "list"] })

            toast.success("Cancelamento cadastrado com sucesso!");
            history.push("/cancelamentos");
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(error?.response?.data?.detail[0] || "Algo deu errado, tente novamente!");
        },
    });

    return mutation;
}
